module.exports = __webpack_public_path__ + "static/laseroterapia-image-1-c64c08f6850e4bfb122a37e0c589c6ec.png";